var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-call-container',{attrs:{"user":_vm.user},scopedSlots:_vm._u([{key:"videoCallRoom",fn:function(ref){
var user = ref.user;
var participants = ref.participants;
var mainScreenParticipant = ref.mainScreenParticipant;
var handleHangUp = ref.handleHangUp;
var handleChangeMainScreen = ref.handleChangeMainScreen;
return [_c('video-call-room',{attrs:{"user":user,"participants":participants,"mainScreenParticipant":mainScreenParticipant},on:{"hangup":handleHangUp,"changeMainScreen":handleChangeMainScreen}})]}}])}),_c('video-call-incoming-container',{attrs:{"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }